<template>
  <div class="download-csv__wrapper">
    <div class="download-csv">
      <div class="dates__input">
        <label class="field__label">From</label>
        <div class="dates__wrapper">
          <datepicker
            v-model="fromDate"
            :wrapper-class="'vdp-datepicker field__input'"
            :input-class="'input'"
            id="from_field"
            @input="checkCanDownload"
          />
        </div>
      </div>
      <div class="dates__input">
        <label class="field__label">To</label>
        <div class="dates__wrapper">
          <datepicker
            v-model="toDate"
            :wrapper-class="'vdp-datepicker field__input'"
            :input-class="'input'"
            id="to_field"
            @input="checkCanDownload"
          />
        </div>
      </div>
      <div
        class="download-csv__export"
      >
        <button
          :class="{'disabled': !canDownloadCsv}"
          class="button success"
          name="generate_report_btn"
          id="generate_report_btn"
          @click="downloadCSV"
        >
          Generate Report
        </button>
      </div>
      <div
        v-if="canClearFilter"
        class="download-csv__clear"
      >
        <button
          class="button success"
          @click="clearFilter"
        >
          Clear filter
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import axios from 'axios';

export default {
  name: 'DownloadCsv',
  components: { Datepicker },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      toDate: '',
      fromDate: '',
      canDownloadCsv: false,
      canClearFilter: false,
    };
  },
  methods: {
    checkCanDownload() {
      if (this.fromDate === '' || this.toDate === '') {
        this.canDownloadCsv = false;
        this.canClearFilter = true;
      } else {
        this.canDownloadCsv = true;
        this.canClearFilter = true;
      }
    },
    clearFilter() {
      this.fromDate = '';
      this.toDate = '';
      this.canClearFilter = false;
      this.canDownloadCsv = false;
    },
    downloadCSV() {
      if (this.canDownloadCsv) {
        axios
          .post(this.resource, {
            from: this.fromDate,
            to: this.toDate,
          })
          .then((response) => {
            this.$emit('report-created', response.data);
          });
      }
    },
  },
};
</script>

<style lang="scss">
.download-csv {
    display: grid;
    grid-template-columns: minmax(min-content, 300px) minmax(min-content, 300px) minmax(min-content, auto) 1fr;
    grid-gap: 1rem;

    @media (max-width: 1200px) {
        grid-template-columns: 1fr;
    }

    &__wrapper {
      display: block;
      width: 100%;
      margin-bottom: 2rem;
    }
    .dates__input {
        display: grid;
        grid-template-columns: 1fr 8fr;
        align-items: baseline;
    }
    .field__input {
        &:after {
            content: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='30px' height='30px' viewBox='0 0 30 30' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 44.1 (41455) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3ECalendar%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='1.0---Willmott Dixon-Pre-Enrol---Desktop---Registration---All-Users' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='2.2---Register---Qualifications' transform='translate(-371.000000, -401.000000)' fill='%234a4a4a59'%3E%3Cg id='1---CSCS-Card' transform='translate(100.000000, 190.000000)'%3E%3Cg id='DOB' transform='translate(85.000000, 167.000000)'%3E%3Cg id='Group-4' transform='translate(0.000000, 32.000000)'%3E%3Cpath d='M212.97,15.72 L211.11,15.72 L211.11,14.325 C211.11,13.041414 210.068586,12 208.785,12 C207.501414,12 206.46,13.041414 206.46,14.325 L206.46,15.72 L195.3,15.72 L195.3,14.325 C195.3,13.041414 194.258586,12 192.975,12 C191.691414,12 190.65,13.041414 190.65,14.325 L190.65,15.72 L188.79,15.72 C187.249672,15.72 186,16.969672 186,18.51 L186,38.97 C186,40.510328 187.249672,41.76 188.79,41.76 L212.97,41.76 C214.510328,41.76 215.76,40.510328 215.76,38.97 L215.76,18.51 C215.76,16.969672 214.510328,15.72 212.97,15.72 Z M212.04,38.04 L189.72,38.04 L189.72,22.23 L212.04,22.23 L212.04,38.04 Z M192.51,27.81 L192.51,25.95 C192.51,25.436578 192.926578,25.02 193.44,25.02 L195.3,25.02 C195.813422,25.02 196.23,25.436578 196.23,25.95 L196.23,27.81 C196.23,28.323422 195.813422,28.74 195.3,28.74 L193.44,28.74 C192.926578,28.74 192.51,28.323422 192.51,27.81 Z M199.02,27.81 L199.02,25.95 C199.02,25.436578 199.436578,25.02 199.95,25.02 L201.81,25.02 C202.323422,25.02 202.74,25.436578 202.74,25.95 L202.74,27.81 C202.74,28.323422 202.323422,28.74 201.81,28.74 L199.95,28.74 C199.436578,28.74 199.02,28.323422 199.02,27.81 Z M205.53,27.81 L205.53,25.95 C205.53,25.436578 205.946578,25.02 206.46,25.02 L208.32,25.02 C208.833422,25.02 209.25,25.436578 209.25,25.95 L209.25,27.81 C209.25,28.323422 208.833422,28.74 208.32,28.74 L206.46,28.74 C205.946578,28.74 205.53,28.323422 205.53,27.81 Z M192.51,34.32 L192.51,32.46 C192.51,31.946578 192.926578,31.53 193.44,31.53 L195.3,31.53 C195.813422,31.53 196.23,31.946578 196.23,32.46 L196.23,34.32 C196.23,34.833422 195.813422,35.25 195.3,35.25 L193.44,35.25 C192.926578,35.25 192.51,34.833422 192.51,34.32 Z M199.02,34.32 L199.02,32.46 C199.02,31.946578 199.436578,31.53 199.95,31.53 L201.81,31.53 C202.323422,31.53 202.74,31.946578 202.74,32.46 L202.74,34.32 C202.74,34.833422 202.323422,35.25 201.81,35.25 L199.95,35.25 C199.436578,35.25 199.02,34.833422 199.02,34.32 Z' id='Page-1'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
            position: relative;
            height: 1rem;
            top: -2.6rem;
            left: -0.8rem;
            float: right;
        }
    }

    svg {
        vertical-align: top;
    }

    &__lcoName {
        width: 47%;
    }

    &__header {
        cursor: pointer;
    }

    .field__label {
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        @media (max-width: 700px) {
            min-width: 3rem;
            text-align: end;
        }
    }

    .field__input .input[readonly] {
        background-color: inherit;
    }

    .vdp-datepicker {
        display: inline-block;
        &__calendar {
            .cell:not(.blank):not(.disabled).day:hover,
            .cell:not(.blank):not(.disabled).month:hover,
            .cell:not(.blank):not(.disabled).year:hover {
                border: 1px solid #3bb498;
            }
            .cell.selected {
                background: #50d8b9;
            }
            .cell.selected:hover {
                background: #50d8b9;
            }
        }
    }

    &__export,
    &__clear {
        display: inline;
    }
}
</style>
